import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { CarouselSpotItem } from '@impact/data';
import { IMPACT_OVERLAY_DATA, ImpactOverlayRef } from '@impactdk/ngx-overlay';

@Component({
    selector: 'app-used-car-gallery-slider',
    template: `
        <section>
            <app-used-car-gallery-cta *ngIf="showCtaPopup" (readyToRemove)="removeCtaPopup()"></app-used-car-gallery-cta>
            <app-media-slider
                [sliderItems]="images"
                [showNavigation]="true"
                [showThumbs]="false"
                [startIndex]="startIndex"
                (closed)="onSliderClose()"
                (indexChange)="onIndexChange($event)"
            ></app-media-slider>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsedCarGalleryComponent {
    images: CarouselSpotItem[] = [];
    showCtaPopup = false;
    startIndex: number;

    @HostListener('document:keydown.esc', ['$event'])
    onEscapeClose(): void {
        this.onSliderClose();
    }

    constructor(private overlayRef: ImpactOverlayRef, @Inject(IMPACT_OVERLAY_DATA) public data: { images: [], startIndex?: number }) {
        this.startIndex = this.data?.startIndex ?? 0;
        this.images = this.data.images.map<CarouselSpotItem>((pictureUrl) => ({
            media: {
                src: pictureUrl,
                type: 'image',
                focalPoint: {
                    left: 0.5,
                    top: 0.5,
                },
            },
        }));
    }

    onIndexChange(index: number) {
        this.showCtaPopup = index + 1 === this.images.length;
    }

    onSliderClose() {
        this.removeCtaPopup();
        this.overlayRef.close();
    }

    removeCtaPopup() {
        this.showCtaPopup = false;
    }
}
